<template>
  <UikitDialog
    :model-value="modelValue"
    position="right"
    full-height
    content-class="osk-sizes-info-dialog"
    @update:model-value="emits('update:modelValue', $event)"
  >
    <ProductSizesInfo
      :product="product"
      :size="size"
      :size-types="sizeTypes"
      @apply="handleApply"
    />
  </UikitDialog>
</template>

<script setup lang="ts">
import { OrderPositionDTORes, SizeValueDTORes, SizeTypeDTO } from '~/restAPI/data-contracts';

const props = defineProps<{
  modelValue: boolean,
  product?: OrderPositionDTORes
  size?: SizeValueDTORes
  sizeTypes?: SizeTypeDTO[] | null
}>();

const emits = defineEmits<{
  (e: 'update:modelValue', value: boolean): void,
  (e: 'update:size', value: SizeValueDTORes): void,
}>();

function handleApply(size: SizeValueDTORes) {
  emits('update:size', size);
  emits('update:modelValue', false);
}
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

.osk-sizes-info-dialog {
  .osk-dialog__close {
    top: 16px;
    right: 16px;

    @include media-query(md-and-up) {
      top: 44px;
      right: 44px;
    }
  }
}
</style>
